import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MenuController } from "@ionic/angular";
import { AppRoutes } from "src/app/constants";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { RootState } from "src/app/store";
import * as UserActions from "src/app/store/user/actions";
import * as FromUser from "src/app/store/user/selectors";
import { Observable } from "rxjs";
import { Browser } from "@capacitor/browser";
import { mustMatch } from "src/app/validators/must-match/must-match.validator";

@Component({
  selector: "app-register",
  templateUrl: "./register.page.html",
  styleUrls: ["./register.page.scss"],
})
export class RegisterPage implements OnInit {
  public loading$: Observable<boolean> = this.store.select(FromUser.selectLoading);
  public routes: typeof AppRoutes = AppRoutes;
  public email = this.activatedRoute.snapshot.queryParamMap.get("email");
  public password = this.activatedRoute.snapshot.queryParamMap.get("password");
  public form: FormGroup;
  public showPassword: boolean;
  public showPasswordRepeat: boolean;

  constructor(private menu: MenuController, private store: Store<RootState>, private activatedRoute: ActivatedRoute) {
    this.menu.enable(false);
  }

  public ngOnInit(): void {
    this.form = new FormGroup(
      {
        email: new FormControl(this.email, [Validators.required, Validators.email]),
        password: new FormControl(this.password, [Validators.required, Validators.minLength(6)]),
        passwordRepeat: new FormControl(this.password, [Validators.required, Validators.minLength(6)]),
      },
      {
        validators: mustMatch("password", "passwordRepeat"),
      },
    );
  }

  public toggleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }

  public toggleShowPasswordRepeat(): void {
    this.showPasswordRepeat = !this.showPasswordRepeat;
  }

  public doRegister(): void {
    const { email, password } = this.form.value;

    this.store.dispatch(
      UserActions.register({
        registerDto: { email, password },
      }),
    );
  }

  public openHelp(): void {
    Browser.open({ url: "https://hilfe.wowfamily.de" });
  }
}
